import { getBetTitleComboBetProps, getBetStatusLabelProps, getSelectionTitlesListProps, getBonusDetailsListProps, getTotalReturnProps, getSelectionDetailsListProps, getBetSummaryProps, isBonusAvailable } from "../bet";
export const getComboBetProps = (bet, state) => {
    const props = {
        betTitle: getBetTitleComboBetProps(bet, state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        selectionTitlesList: getSelectionTitlesListProps(bet, state),
        totalReturn: getTotalReturnProps(bet, state),
        selectionDetailsList: getSelectionDetailsListProps(bet, state),
        betSummary: getBetSummaryProps(bet, state)
    };
    if (isBonusAvailable(bet)) {
        props.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return props;
};
//# sourceMappingURL=getComboBetProps.js.map